import Http from '@/api/http.js'

export default {
  index(params = {}) {
    return Http.get('/whatsapp_messages', { params })
  },

  requeue(id) {
    return Http.post(`/whatsapp_messages/${id}/requeue`)
  },

  update(id, payload) {
    return Http.put(`/whatsapp_messages/${id}`, payload)
  },
}
